<script lang="ts">
  import { Col, Image, Row } from "sveltestrap";
  import { ProjectDescription, discription4 } from "../../../../utils/Constant/Constant";
  let imgPath:string = "/assets/images"

</script>
<Row class="invo-profile">
    <Col xl="4">
      <div class="media">
        <div class="media-left">
            <Image class="media-object rounded-circle img-60" src="{imgPath}/user/1.jpg" alt=""/>
        </div>
        <div class="media-body m-l-20">
          <h4 class="media-heading">{'Johan Deo'}</h4>
          <p>{'JohanDeo@gmail.com'}<br><span class="digits">{'555-555-5555'}</span></p>
        </div>
      </div>
    </Col>
    <Col xl="8">
      <div class="text-xl-end" id="project">
        <h6>{ProjectDescription}</h6>
        <p>{discription4}</p>
      </div>
    </Col>
</Row>